import { put } from 'redux-saga/effects';
import DistributorsActions from '../redux/DistributorsRedux';
import i18n from '../i18n';
import decode from 'jwt-decode';

export function* getDistributorInfo(api, { distributorId }) {
  try {
    const getDistributorInfoResponse = yield api.getDistributorInfo(distributorId);
    // console.log('getDistributorInfoResponse:', getDistributorInfoResponse);
    if (getDistributorInfoResponse.ok) {
      const { data } = getDistributorInfoResponse;
      const distributorIdSub = data && data.distributorId ? decode(data.distributorId).sub : null;
      const distributorWithSub = { ...data, distributorIdSub };
      yield put(DistributorsActions.getDistributorInfoRequestSuccess(distributorWithSub));
    } else {
      api.checkAuth(getDistributorInfoResponse);
      const error =
        typeof getDistributorInfoResponse.problem !== 'undefined'
          ? getDistributorInfoResponse.problem
          : typeof getDistributorInfoResponse.data.error !== 'undefined'
            ? i18n.t(getDistributorInfoResponse.data.error)
            : i18n.t('unexpectedError');
      yield put(DistributorsActions.getDistributorInfoRequestFailure(error));
    }
  } catch (error) {
    console.log('error in distributors saga', error);
    yield put(DistributorsActions.getDistributorInfoRequestFailure(error));
  }
}

export function* getDistributorsList(api, { pageParams }) {
  try {
    const getDistributorsListResponse = yield api.getDistributorsList(pageParams);
    if (getDistributorsListResponse.ok) {
      const content = getDistributorsListResponse.data.content;
      const distributorsWithSub = content.map((distributor) => {
        const decodedToken = distributor && distributor.distributorId ? decode(distributor.distributorId) : null;
        const distributorIdSub = decodedToken ? decodedToken.sub : null;
        return { ...distributor, distributorIdSub };
      });
      yield put(DistributorsActions.getDistributorsListRequestSuccess(distributorsWithSub));
    } else {
      api.checkAuth(getDistributorsListResponse);
      const error =
        typeof getDistributorsListResponse.problem !== 'undefined'
          ? getDistributorsListResponse.problem
          : typeof getDistributorsListResponse.data.error !== 'undefined'
            ? i18n.t(getDistributorsListResponse.data.error)
            : i18n.t('unexpectedError');
      yield put(DistributorsActions.getDistributorsListRequestFailure(error));
    }
  } catch (error) {
    console.log('error in distributors saga', error);
    yield put(DistributorsActions.getDistributorsListRequestFailure(error));
  }
}
